import { Component, computed, input, output } from '@angular/core';
import { ButtonComponent } from '../../../../../../shared/components/button/button.component';
import { ClaimJump } from '../../../../types/claim-form.types';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-summary-section',
  imports: [ButtonComponent, DatePipe],
  templateUrl: './summary-section.component.html',
  styleUrl: './summary-section.component.scss',
})
export class SummarySectionComponent {
  resumeStep = output<void>();

  step = input.required<ClaimJump>();

  index = input.required<number>();

  private viewModel = computed(() => {
    console.log(this.step());
    return {
      index: this.index(),
      canEdit: this.step().resumableFromCurrent && this.step().direction === 'BACKWARDS',
      sectionTitle: this.step().to.step,
      activeStep: this.step().direction === 'ACTIVE',
      stepCompleted: this.step().completed,
      stepNotStarted: this.step().direction === 'FORWARDS',
      isStepBehindCurrentStep: this.step().direction === 'BACKWARDS',
      stepValues: (this.step().values ?? []).filter((v) => !!v.value && v.value !== ''),
    };
  });

  get vm() {
    return this.viewModel();
  }

  nameMapping: Record<string, string> = {
    'claim-type': 'How it happened',
    appliance_details: "What's wrong",
    fault_questions: 'When it started',
    contact_details: 'Your details',
    launch_repair: 'Pick a date',
    visit_appointment: 'Pick a date',
    service_options: 'Type of visit',
    initial_visit_appointment: 'Pick a date',
  };
}
